import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'
import { SearchType } from '@shared/shared.types'

@Injectable()
export class SearchResultsService {
  constructor(private http: HttpClient) {}

  public fetchSearchResults({
    keyword,
    type,
    page_size,
    page,
  }): Observable<any> {
    const searchTypes = {
      [SearchType.LICENSE]: 'bl',
      [SearchType.PAYABLE]: 'payable',
      [SearchType.PAYMENT]: 'payment',
      [SearchType.PROPERTY_RDN]: 'rdn',
    }
    const url = `${environment.API_ENDPOINT}/search/${searchTypes[type]}`

    const filters = {}

    if (
      type == SearchType.PROPERTY_RDN ||
      type == SearchType.LICENSE ||
      type == SearchType.PAYABLE
    ) {
      filters['or'] = [{ field: 'referenceId', value: keyword }]
    } else {
      filters['or'] = [{ field: 'id', value: keyword }]
    }

    return this.http.post(url, {
      filters,
      pageSize: parseInt(page_size),
      page: parseInt(page) - 1,
    })
  }
}
